import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/service/$slug")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/$hubSlug", params: { hubSlug: params.slug }, replace: true });
  },
  component: () => null,
});
